"use client";

import { useEffect, useState } from "react";
import { Card, EmptyState } from "@/components/ui";
import { loadEquipmentDemoDistributionLinkByToken } from "@/lib/api";
import { EquipmentDemoPage } from "@/components/pages/equipment-demo-page";

export function EquipmentDemoAccessPage({ token }: { token: string }) {
  const [status, setStatus] = useState<"loading" | "ready" | "inactive" | "missing">("loading");

  useEffect(() => {
    let cancelled = false;
    loadEquipmentDemoDistributionLinkByToken(token)
      .then((result) => {
        if (cancelled) return;
        if (!result.data) {
          setStatus("missing");
          return;
        }
        if (result.data.status !== "active") {
          setStatus("inactive");
          return;
        }
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) setStatus("missing");
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (status === "loading") {
    return (
      <div className="min-h-screen bg-[#eef2f5] p-6">
        <Card>
          <EmptyState title="점검 링크를 확인하는 중입니다" description="잠시만 기다려 주세요." />
        </Card>
      </div>
    );
  }

  if (status === "inactive") {
    return (
      <div className="min-h-screen bg-[#eef2f5] p-6">
        <Card>
          <EmptyState title="비활성화된 링크입니다" description="관리자에게 새 링크를 요청해 주세요." />
        </Card>
      </div>
    );
  }

  if (status === "missing") {
    return (
      <div className="min-h-screen bg-[#eef2f5] p-6">
        <Card>
          <EmptyState title="유효하지 않은 링크입니다" description="링크 주소를 다시 확인해 주세요." />
        </Card>
      </div>
    );
  }

  return <EquipmentDemoPage distributionToken={token} sharedAccess />;
}
